import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header.js";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import Lottie from "lottie-react";
import Cookies from "js-cookie";
import { useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Call_Api from "../../Common/Handileapi/Call_api.js";
import { path } from "../../routes/Paths.jsx";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { StoreUser } from "../../redux/slice/userDetailsSlice.js";
import NtarLoader from "../../components/Loaders/NtarLoader.jsx";
import useUserData from "../../Common/updateUser/updateUser.jsx";
import {
  isFeatureActive,
  isFeatureServiceActive,
} from "../../Common/serviceActiveCheck/serviceActiveCheck.js";
import { ImagesPath } from "../../Common/imagespath/imagespath";
import { data } from "../../Common/Text/NormalText.js";
import { Modal as AntdModal } from "antd";
import "../../styles/CreditCardBillPayments.css";
import ReusableModal from "../../Common/ReusableModal.jsx";

const CreditCardInstantBbps = ({ hideHeader }) => {
  const token = Cookies.get("token");
  const MerchantId = Cookies.get("MerchantId");
  const mobileNumber = Cookies.get("mobileNumber");

  const dispatch = useDispatch();
  const navigation = useNavigate();

  const { getUserDetails } = useUserData();
  const detailsToSend = useSelector((state) => state.details.details);
  const userDetails = useSelector((state) => state.user.user);
  const features = useSelector((state) => state.activeFeatures.features);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDetails, setModalDetails] = useState({
    title: "",
    message: "",
    confirmText: "",
    cancelText: "",
    onConfirm: null,
  });
  const date = new Date();
  const [cardDetails, setCardDetails] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [cardDataLoading, setCardDataLoading] = useState(false);
  const [billamountValidations, setBillAmountValidations] = useState({
    minAmount: 0,
    maxAmount: 0,
  });

  useEffect(() => {
    if (userDetails?.walletStatus?.toLowerCase() == "active") {
      const initialize = async () => {
        await getUserDetails();
        await fetchCardDetails();
        await fetchWalletCharges();
      };
      initialize();
      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          amountValidations: { minAmount: 0, maxAmount: 0 },
        }),
      );
    } else {
      const initialize = async () => {
        await getUserDetails();
        await fetchCardDetails();
      };
      initialize();
      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          amountValidations: { minAmount: 0, maxAmount: 0 },
        }),
      );
    }
  }, []);

 useEffect(() => {
  const term = searchTerm?.toLowerCase() || "";

  const filtered = cardDetails.filter((card) => (
    card.customerName?.toLowerCase().includes(term) ||
    card.creditCardNumber?.slice(-4).includes(term) ||
    card.customerMobileNumber?.includes(term)
  ));

  setFilteredCards(filtered);
}, [searchTerm, cardDetails]);

  const fetchCardDetails = async () => {
    try {
      const res = await Call_Api(
        path.GET_CREDITCARDDETAILS_INSTANT_BBPS("INSTANT_BBPS"),
        "GET",
        {},
        token,
      );
      console.log("res in credit card details of instant bbps===>", res);
      if (res?.success && res?.response?.success) {
        setCardDetails(res.response?.data);
      } else {
        setCardDetails([]);
      }
    } catch (err) {
      console.error("Error fetching card details:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchWalletCharges = async () => {
    try {
      const details = {
        paymentMethod: "Credit Card",
        paymentMode: "Credit Card",
        paymentType: "Credit Card",
        serviceName: "PayOut",
      };
      const res = await Call_Api(
        path.BBPS_GET_WALLET_PAYOUT_CHARGES,
        "POST",
        details,
        token,
      );
      if (res?.response?.length > 0) {
        const { payOutFee, payOutPercentage } = res.response[0];
        const chargeAmount =
          Number(payOutFee) ||
          (Number(payOutPercentage) / 100) * (detailsToSend?.actualAmount || 0);

        dispatch(
          setDetailsToSend({
            ...detailsToSend,
            payOutFee,
            payOutPercentage,
            payOutChargedAmount: chargeAmount,
            chargedAmount: chargeAmount,
          }),
        );
      }
    } catch (err) {
      console.error("Error fetching wallet payout charges:", err);
    }
  };

  const handleDeleteCard = async (card) => {
    try {
      const res = await Call_Api(
        path.Update_CREDITCARDDETAILS,
        "PUT",
        {
          _id: card?._id,
        },
        token,
      );

      if (res?.success) {
        await fetchCardDetails();
      }
    } catch (err) {
      console.error("Error deleting card:", err);
    }
  };

  const generateTransactionId = () => {
    const now = new Date();
    const date = now.toISOString().slice(0, 10).replace(/-/g, "");
    const time = now.toISOString().slice(11, 19).replace(/:/g, "");
    const random = Math.random().toString(36).substr(2, 4).toUpperCase();
    return `BIZZ_${date}${time}${random}`;
  };

  const handleShowKycModal = () => {
    setModalDetails({
      title: "Re Kyc Required",
      message:
        "Please complete re Kyc to continue using this service in mobile Application",
      confirmText: "Okay Got it",
      cancelText: "Cancel",
      onConfirm: () => {
        setModalOpen(false);
      },
    });
    setModalOpen(true);
  };

  const fetchBillInfo = async (card, skipCardLengthCheck = false) => {
    console.log("card in fetchBillInfo in existing cards", card);
    if (
      !isFeatureServiceActive(
        features,
        "Credit_Card_Bill_Payment",
        "INSTANT_BBPS",
      )
    ) {
      return AntdModal.info({
        title: "Service Unavailable",
        content: <p>{data?.serviceUnavailable}</p>,
        onOk() {
          console.log("User acknowledged wallet inactivity");
        },
      });
    }

    const billUniqueId = card?.billerId;
    const res = await Call_Api(
      path.BBPS_PAY_INFO(billUniqueId),
      "GET",
      "",
      token,
    );
    console.log("res in pay option", res);
    if (res?.response?.payOptions?.payOption?.toLowerCase() == "instant_bbps") {
      if (!userDetails?.IpayOutletId) {
        handleShowKycModal();
        return;
      }
      const newData = {
        ...detailsToSend,
        billerId: card?.billerId,
        customerMobileNumber: card?.customerMobileNumber,
        creditCardNumber: card?.creditCardNumber,
        subService: card?.subService,
        billerLogo: card?.billerLogo,
        serviceName: "Credit Card",
        billerName: card?.subService,
        parameters: card?.inputParams,
        payOption: "INSTANT_BBPS",
        ntarTransactionId: generateTransactionId(),
      };
      dispatch(setDetailsToSend(newData));
      sessionStorage.setItem("origin", "existing");
      navigation("/payScreen", { state: { origin: "existing" } });
      return;
    }
    if (res?.response?.payOptions?.payOption?.toLowerCase() == "bbps") {
      const newDetails = { billerId: card.billerId, billType: "billerInfo" };
      setCardDataLoading(true);
      try {
        const res = await Call_Api(
          path.BBPS_BILL_INFO,
          "POST",
          newDetails,
          token,
        );
        console.log("res in fetchBillInfo ===>>", res);
        const info =
          res?.response?.jsonData?.billerInfoResponse?.biller
            ?.billerPaymentChannels?.paymentChannelInfo;
        console.log("info in credit card bill payment", info);
        const minAmount = info?.[0]?.minAmount;
        const maxAmount = info?.[0]?.maxAmount;
        const agt = info?.find((x) => x.paymentChannelName.includes("AGT"));
        let minMaxAmount = {
          minAmount,
          maxAmount,
        };
        console.log("agt in fetchBillInfo ===>>", agt);
        const bbpsChannel = agt || "MOB";
        const payGateWay = res?.response?.jsonData?.payOutGateWay;
        console.log("payGateWay in existing credit card====>>", payGateWay);
        const updatedDetails = {
          ...detailsToSend,
          activeService: payGateWay,
          payOutGateWay: payGateWay,
        };
        console.log(
          `updated Details to send in biller info from existing cards ===>>`,
          JSON.stringify(updatedDetails),
        );
        if (
          res?.response?.jsonData?.billerInfoResponse?.biller?.billerFetchRequiremet?.toUpperCase() ===
          "MANDATORY"
        ) {
          console.log(
            "FetchBill is called in existing bill avenue creditCard Details ====>>",
          );
          await fetchBill(card, bbpsChannel, minMaxAmount, payGateWay);
        }
      } catch (err) {
        console.error("Error fetching bill info:", err);
        AntdModal.error({
          title: "Bill Fetch Failed",
          content: (
            <p>
              {err.message ||
                "Unable to fetch bill details at the moment. Please try again later."}
            </p>
          ),
          onOk() {
            console.log("User acknowledged bill fetch error");
          },
        });
      } finally {
        setCardDataLoading(false);
      }
    }
  };

  const fetchBill = async (card, channel, minMaxAmount, payGateWay) => {
    console.log("minMaxAmount==>", minMaxAmount);
    const newDetails = {
      billType: "billFetch",
      mobileNumber,
      billerId: card.billerId,
      inputParams: card.inputParams,
      channelName: channel?.paymentChannelName,
      activeService: payGateWay,
      payOutGateWay: payGateWay,
    };
    console.log(
      "calling bill fetch in existing cards==>",
      JSON.stringify(newDetails),
    );
    const ntarTransactionId = generateTransactionId();
    try {
      const res = await Call_Api(
        path.BBPS_BILLFETCH_SECONDCALL,
        "POST",
        newDetails,
        token,
      );
      console.log("res in credit card bill payments", res);
      const code =
        res?.response?.jsonData?.billFetchResponse?.responseCode?.trim();

      if (code === "000") {
        const billerResponse =
          res.response.jsonData.billFetchResponse.billerResponse;
        let additionalInfoRaw =
          res.response?.jsonData?.billFetchResponse?.additionalInfo?.info;

        const additionalInfo = Array.isArray(additionalInfoRaw)
          ? additionalInfoRaw
          : additionalInfoRaw
            ? [additionalInfoRaw]
            : [];

        const requestId = res.response.requestId;

        const updatedDetails = {
          ...detailsToSend,
          Operator: card,
          CreditCard: card,
          billType: "billPayRequest",
          serviceName: "Credit Card",
          paymentMode: "Credit Card",
          transactionType: "Debit",
          subService: card.subService,
          billerId: card.billerId,
          paymentInfo: [
            {
              creditCardNumber: card.creditCardNumber,
              customerMobileNumber: card.customerMobileNumber,
            },
          ],
          customerMobileNumber: card.customerMobileNumber,
          billerLogo: card.billerLogo,
          inputParams: card.inputParams,
          billerResponse,
          additionalInfo,
          requestId,
          billDate: billerResponse?.billDate,
          billDueDate: billerResponse?.dueDate,
          customerName: billerResponse?.customerName,
          channelName: channel?.paymentChannelName,
          creditCardNumber: card.creditCardNumber,
          bbpsCreditCardNumber: card.creditCardNumber,
          amountValidations: minMaxAmount,
          MerchantId,
          userName: userDetails?.userName,
          mobileNumber,
          ntarTransactionId,
          paymentSource: "webApp",
          activeService: payGateWay,
          payOutGateWay: payGateWay,
        };

        dispatch(setDetailsToSend(updatedDetails));
        navigation("/CreditCardPaymentPay", {
          state: { detailsToSend: updatedDetails, userDetails },
        });
      } else if (code == "001") {
        AntdModal.info({
          title: "Bill Fetch",
          content: (
            <p>
              {res?.response?.jsonData?.billFetchResponse?.errorInfo?.error
                ?.errorMessage ||
                "Unable to fetch bill details at the moment. Please try again later."}
            </p>
          ),
          onOk() {
            console.log("User acknowledged bill fetch error");
          },
        });
      } else {
        console.log("Bill fetch failed with code:", code);
        throw new Error("Bill fetch failed. Please try again.");
      }
    } catch (err) {
      console.error("Error fetching bill:", err);
      throw new Error("Bill fetch failed. Please try again.");
    }
  };

  if (!isFeatureActive(features, "Credit_Card_Bill_Payment", "INSTANT_BBPS")) {
    return <Navigate to="/" />;
  }

  if (isLoading || cardDataLoading) return <NtarLoader />;

  return (
    <>
      {!hideHeader && <Header title="Credit Card Bill Payments" />}

      <div
        className={`qr-form-creditcardbill-v ${
          !isFeatureServiceActive(
            features,
            "Credit_Card_Bill_Payment",
            "INSTANT_BBPS",
          )
            ? "disabled"
            : ""
        } ${hideHeader ? "no-bg" : ""}`}
      >
        <div className="qr-form-creditcardbill-v__container">
          {!isFeatureServiceActive(
            features,
            "Credit_Card_Bill_Payment",
            "INSTANT_BBPS",
          ) && (
            <div className="pay_active_service_s">
              <p className="error_service_down">{data?.seriveDown}</p>
            </div>
          )}
          <div className="qr-form-billpay-v">
            {cardDetails.length > 0 && (
              <div className="search-container-credit-card-billpay-v">
                <div className="search-container-v">
                  <div className="search-box-v">
                    <div className="search-icon-wrapper-v">
                      <SearchIcon className="search-icon-v" />
                    </div>
                    <input
                      type="text"
                      placeholder="Search for Credit Card"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <button
                    className="add-button-v"
                    onClick={() => {
                      dispatch(
                        setDetailsToSend({
                          ...detailsToSend,
                          creditCardNumber: "",
                          serviceName: "Credit Card",
                          payOutFee: "0",
                          payOutPercentage: 0,
                          payOutChargedAmount: 0,
                          chargedAmount: 0,
                        }),
                      );
                      navigation("/bbps/Credit Card Bbps", {
                        state: {
                          record: "Credit Card",
                          key: "",
                          billUnique: "",
                          cardData: "",
                        },
                      });
                    }}
                  >
                    <AddIcon className="addicon-bg" /> {data?.add}
                  </button>
                </div>
              </div>
            )}

            <div className="payee-list-v">
              {cardDetails.length === 0 && (
                <div className="empty-card-container">
                  <div className="lottie-wrapper-addcardjson">
                    <Lottie
                      animationData={
                        ImagesPath?.CreditCardBillPayments?.NtarLoader
                      }
                      loop={true}
                    />
                  </div>
                  <div className="cd-addcard-div">
                    <button
                      className="cd-addcardbutton"
                      onClick={() => {
                        dispatch(
                          setDetailsToSend({
                            ...detailsToSend,
                            creditCardNumber: "",
                            serviceName: "Credit Card",
                            payOutFee: "0",
                            payOutPercentage: 0,
                            payOutChargedAmount: 0,
                            chargedAmount: 0,
                          }),
                        );
                        navigation("/bbps/Credit Card Bbps", {
                          state: {
                            record: "Credit Card",
                            cardData: "",
                            billUnique: "",
                            key: "",
                          },
                        });
                      }}
                    >
                      {data?.cardAdd}
                      <img
                        className="cd-addicon-size"
                        src={ImagesPath?.CreditCardBillPayments?.Addcard}
                        alt="Add"
                      />
                    </button>
                  </div>
                </div>
              )}
              <div className="scrollable-cards-container">
                {filteredCards?.length > 0 ? (
                  filteredCards?.map((card, i) => (
                    <div className="payee-card-v" key={i}>
                      <div className="payee-info-v">
                        <div className="payee-icon-v">
                          <img src={card?.billerLogo} alt="Bank Icon" />
                        </div>
                        <div className="payee-details-v">
                          <h3>
                            {card?.customerName ||
                              card?.customerName?.subService}
                          </h3>
                          <p className="credit_no_s">
                            {card?.creditCardNumber?.length > 10
                              ? `XXXX${card?.creditCardNumber?.slice(-4)}`
                              : card?.creditCardNumber}
                          </p>
                          <p className="mobile_no_s">
                            {card?.customerMobileNumber}
                          </p>
                        </div>
                      </div>
                      <div className="delete-info-v">
                        <button
                          className="pay-now-btn-v"
                          onClick={() => fetchBillInfo(card)}
                        >
                          {data?.pNow}
                        </button>
                        <Popconfirm
                          title="Deleting Credit Card"
                          description="Are you sure to delete this Card Details?"
                          icon={
                            <QuestionCircleOutlined
                              style={{ color: "var(--red)" }}
                            />
                          }
                          onConfirm={() => handleDeleteCard(card)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <DeleteOutlineOutlinedIcon
                            sx={{
                              fontSize: "1.5rem",
                              color: "#FF0000",
                              cursor: "pointer",
                            }}
                          />
                        </Popconfirm>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>{data?.noData}</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReusableModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={modalDetails.onConfirm}
        title={modalDetails.title}
        message={modalDetails.message}
        confirmText={modalDetails.confirmText}
        cancelText={modalDetails.cancelText}
      />
    </>
  );
};

export default CreditCardInstantBbps;
